
import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import CategoryProfile from "../screens/CategoryManagement/CategoryProfile";

const breadCrumbData = [{ link: "/category-list", name: "Project List" },
{ link: "/category-detail", name: "Project Detail" }];

const CategoryManagement = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <CategoryProfile />
    </LayoutContainer>
  </>
);

export default CategoryManagement;